import { View, Text, StyleSheet, ImageBackground, Pressable, FlatList } from 'react-native'
import React, { useEffect, useState, createContext, useContext } from 'react';
import { Link } from "react-router-dom";
import { FaBookOpen, FaEdit, FaSun, FaMoon, FaArrowCircleDown, FaDownload, FaTrashAlt, FaHandPointUp, FaScroll, FaRunning, FaSyncAlt, FaMicrophoneAlt, FaMapMarkedAlt, FaPhoneSquare, FaUserAstronaut, FaCalendarDay, FaHeadSideCough, FaHamsa } from "react-icons/fa";
import SayerDetail from './SayerDet.js';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Stack from 'react-bootstrap/Stack';
import Button from 'react-bootstrap/Button';
import ToggleButton from 'react-bootstrap/ToggleButton';
import { PatternFormat, NumericFormat } from 'react-number-format';
import DataTable, { createTheme } from 'react-data-table-component';
import { format } from 'date-fns';
import SayerWork from './WorkSayer.js';

const SayerPanel = () => {
  // Maintan the interpreters
  const apptsUrl = process.env.REACT_APP_APPTS_URL;
  const [isDev, setIsDev] = useState(apptsUrl.search('dev') > 0);
  const [langs, setLangs] = useState([]);
  const [filterLangs, setFilterLangs] = useState([]);
  const [langsActive, setLangsActive] = useState(false);
  const [langsSelect, setLangsSelect] = useState(false);
  const [isActive, setIsActive] = useState(true);

  const [locs, setLocs] = useState([]);
  const [filterLocs, setFilterLocs] = useState([]);
  const [locsActive, setLocsActive] = useState(false);
  const [locsSelect, setLocsSelect] = useState(false);

  const [curNow, setNow] = useState(new Date().toLocaleString());
  const [refreshInterval, setRefreshInterval] = useState(251000);
  const [stat1, setStat1] = useState('hidden');
  const [stat2, setStat2] = useState(null);
  const [stat3, setStat3] = useState(null);
  const btnNormal = "btn btn-sm btn-outline-info";
  const btnOn = "btn btn-sm btn-outline-warning";
  const btnActive = 'active ' + btnNormal;
  const btnDesc = 'active ' + btnOn;
  const btnSelect = "btn btn-sm btn-outline-light";
  const btnSelectOn = 'active ' + btnNormal;

  const [sortType, setSortType] = useState('nametext');
  const [sortActive, setSortActive] = useState(1);
  const sortIcon = <FaArrowCircleDown />;
  // export
  const [exportActive, setExportActive] = useState(0);
  const [exportNoPhone, setExportNoPhone] = useState(false);
  const [exporNoMail, setExportNoMail] = useState(false);
  const [exportNoAddress, setExportNoAddress] = useState(false);

  const styles = createStyles();
  const scrollTop = () => { window.scrollTo(0, 0); }

  function setSort(sortOpt, sortFld) {
    var newSort = sortOpt;
    if (Math.abs(sortActive) === newSort) {
      newSort = sortActive * -1;
    }
    setSortActive(newSort);
    setSortType(sortFld);
    console.log('setSort', sortOpt, sortFld, sortActive, newSort, (Math.abs(sortActive) === newSort));
  }

  // get Master List
  const [masterlist, setMaster] = useState(null);
  const [selectedRec, setSelectedRec] = useState(null);
  const [showRec, setShowRec] = useState(false);

  function sortField(val) {
    var fixed = val;
    if (Math.abs(sortActive) in [1, 2, 4, 7]) {
      if (val) {
        fixed = val.toLowerCase().replaceAll(' ', '').replaceAll('-', '').trim();
      } else {
        fixed = "";
      }
    }
    return fixed
    //if (Number.isNaN(fixed)) { return fixed.toLowerCase().replace(' ', '') } else {  }
  }
  function sorter(a, b) {
    var comp = 0;
    if (sortActive > 0) {
      comp = (sortField(a[sortType]) > sortField(b[sortType]) ? 1 :
        ((sortField(b[sortType]) > sortField(a[sortType])) ? -1 : 0))
    } else {
      comp = (sortField(a[sortType]) < sortField(b[sortType]) ? 1 :
        ((sortField(b[sortType]) < sortField(a[sortType])) ? -1 : 0))
    }
    // console.log('sorter', sortActive, comp, sortField(a[sortType]), sortField(b[sortType]));
    return comp;
  }

  createTheme(
    'solarized',
    {
      text: {
        primary: 'goldenrod',
        secondary: 'orange',
      },
      background: {
        default: 'rgba(48, 0, 48, 0.2)',
      },
      context: {
        background: '#cb4b16',
        text: '#FFFFFF',
      },
      divider: {
        default: 'rgba(48, 0, 48, 0.5)',
      },
      button: {
        default: '#cb4b16',
        hover: 'rgba(0,0,0,.08)',
        focus: 'rgba(255,255,255,.12)',
        disabled: 'rgba(255, 255, 255, .34)',
      },
      sortFocus: {
        default: '#2aa198',
      },
    },
    'dark',
  );
  // Theme
  var ThemeBlob = { theme: 'dark' };
  const themeBlob = () => localStorage.getItem('UsersThemeBlob') ? JSON.parse(localStorage.getItem('UsersThemeBlob')) : ThemeBlob;
  const [dataColor, setDataColor] = React.useState(themeBlob().theme);
  const clickTheme = (theme) => {
    // Handle theme blob ops
    // build a fresh blob and save it
    setDataColor(theme);
    ThemeBlob.theme = theme;
    localStorage.setItem('UsersThemeBlob', JSON.stringify(ThemeBlob));
  }

  function handleEdit(row) {
    console.log('handleEdit', row.sayername);
    setSelectedRec(row);
    setShowRec(true);
  }


  // build the grid. Cells, Columns
  function nameCell(row, idx) {
    // Name
    return (
      <div>
        &nbsp;<button className={btnNormal} onClickCapture={() => { handleEdit(row) }} title="EDIT"><FaEdit /></button>&nbsp;

        {row.sayername &&
          <Link className={btnNormal} target='_blank' to={`/talker/${row.sayername.replace(/ /g, '').toUpperCase()}`}><FaBookOpen />
          </Link>}&nbsp;
        {row.sayername}
        &nbsp;<sup style={row.sayeractive >= 10 ? { color: 'lightgreen' } : { color: 'lightgray' }}>{row.sayeractive >= 10 ? "ACTIVE" : "INACTIVE"}</sup>
      </div>
    );
  };
  function phoneCell(row) {
    // Phone
    return (
      <div>{row.sayerphone && row.sayerphone.slice(0, 3)} {row.sayerphone && row.sayerphone.slice(3, 6)}-{row.sayerphone && row.sayerphone.slice(6, 10)}</div>
    );
  };
  function speaksCell(row) {
    // Speaks
    return (
      <div>{row.sayerspeaks}</div>
    );
  };
  function ratesCell(row) {
    // Rates
    return (
      <div>{row.sayerPerAppt}|{row.sayerNoShow}|{row.sayerPerMile}|{row.sayerMin}|{row.sayerCiel}</div>
    );
  };
  const columns = [
    {
      id: "name-col",
      name: <div style={styles.texttall}>Name</div>,
      selector: row => row.sayername,
      sortable: true,
      style: [styles.texttall,styles.colwide],
      cell: row => nameCell(row),
    },
    {
      id: "phone-col",
      name: <div style={styles.texttall}>Phone</div>,
      selector: row => row.sayerphone,
      sortable: true,
      style: [styles.texttall, styles.colthin],
      cell: row => phoneCell(row),
    },
    {
      id: "email-col",
      name: <div style={styles.texttall}>E-Mail</div>,
      selector: row => row.sayeremail,
      sortable: true,
      style: [styles.texttall, styles.colwide],
    },
    {
      id: "region-col",
      name: <div style={styles.texttall}>Covers</div>,
      selector: row => row.sayerregion,
      sortable: true,
      style: [styles.texttall, styles.colthin],
    },
    {
      id: "speaks-col",
      name: <div style={styles.texttall}>Speaks</div>,
      selector: row => row.sayerspeaks,
      sortable: true,
      style: [styles.texttall, styles.colthin],
      cell: row => speaksCell(row),
    },
    {
      id: "rate-col",
      name: <div style={styles.texttall}>$ Appt</div>,
      selector: row => row.sayerPerAppt,
      sortable: true,
      style: [styles.texttall, styles.colthin],
      cell: row => ratesCell(row),
    },
  ];
  const headerComponent = (
    <div>
      <span className='col' style={{ flex: 6, textAlign: 'left', fontSize: '1.5em' }}>
        Talkers
      </span>
      &nbsp;&nbsp;&nbsp;FILTERS&nbsp;
      <button className={(langsActive || locsActive) ? btnOn : btnNormal} title="Clear Filters for ORGS and LOCS" onClick={() => [setLocsActive(false), setLocsSelect(false), setLangsActive(false), setLangsSelect(false)]}><FaTrashAlt /></button>&nbsp;
      &nbsp;Active:&nbsp;&nbsp;
      <button className={isActive ? btnActive : btnNormal} title="Show ACTIVE" onClick={() => setIsActive(true)}><FaRunning /></button>&nbsp;
      <button className={isActive ? btnOn : btnNormal} title="Clear ACTIVE" onClick={() => setIsActive(false)}><FaTrashAlt /></button>&nbsp;
      &nbsp;Speaks:&nbsp;&nbsp;
      <button className={langsActive ? btnActive : btnNormal} title="Select LANGUAGES" onClick={() => [setLangsActive(true), setLangsSelect(!langsSelect)]}><FaMicrophoneAlt /></button>&nbsp;
      <button className={langsActive ? btnOn : btnNormal} title="Clear LANGUAGES" onClick={() => [setLangsActive(false), setFilterLangs([]), setLangsSelect(false)]}><FaTrashAlt /></button>&nbsp;
      &nbsp;&nbsp;Covers:&nbsp;&nbsp;
      <button className={locsActive ? btnActive : btnNormal} title="Select LOCATIONS" onClick={() => [setLocsActive(true), setLocsSelect(!locsSelect)]}><FaMapMarkedAlt /></button>&nbsp;
      <button className={locsActive ? btnOn : btnNormal} title="Clear LOCATIONS" onClick={() => [setLocsActive(false), setLocsSelect(false)]}><FaTrashAlt /></button>&nbsp;
      <button className={btnNormal} title="EXPORT DATA" onClick={() => [setExportActive(true), exportsShow]}><FaDownload /></button>
      <span style={{ flex: 3, fontSize: '0.8em' }}>
        &nbsp;&nbsp;Last:{curNow}&nbsp;
        <button title='REFRESH' className={btnOn} onClick={() => window.location.reload()}><FaSyncAlt /></button>
      </span>
      <span className='col' style={{ flex: 3 }}>
        &nbsp;<button className={btnOn} onClick={() => clickTheme('default')} ><FaSun title='LIGHT THEME' /></button>
        &nbsp;<button className={btnOn} onClick={() => clickTheme('solarized')} ><FaMoon title='DARK THEME' /></button>
      </span>
      &nbsp;{isDev ? <span className="runningman down">DEV</span> : <span className="runningman up">Live</span>}

      {(showRec) ?
        <SayerWork show={showRec} rec={selectedRec} />
        : <></>}

    </div>
  );
  function userGrid() {
    return (
      <DataTable
        columns={columns}
        data={
          masterlist
            .filter(sayer => (
              (!isActive || (isActive && filterLangs && sayer.sayeractive >= 10)) &&
              (!langsActive || (langsActive && filterLangs && sayer.sayerspeaks && (filterLangs.includes(sayer.sayerspeaks)))) &&
              (!locsActive || (locsActive && filterLocs && sayer.sayerregion && (filterLocs.includes(sayer.sayerregion))))
            ))
        }
        dense='true'
        theme={dataColor}
        striped='true'
        highlightOnHover={true}
        fixedHeader={true}
        title={headerComponent}
        defaultSortFieldId={'name-col'}
        sortIcon={sortIcon}
style={{height:"90%"}}
      />
    );
  };




  useEffect(() => {
    fetchRegions();
    fetchSpoken();
    fetchMetrics();
    if (refreshInterval && refreshInterval > 0) {
      const interval = setInterval(refreshMaster, refreshInterval);
      return () => clearInterval(interval);
    }

  }, [refreshInterval]);


  const fetchSpoken = () => {
    // Load the language select options
    // 
    const langArr = [];
    fetch(`${apptsUrl}getSpoken`)
      .then(response => response.json())
      .then(data2 => {
        data2.forEach((lang) => {
          if (lang.value && !langArr.includes(lang.value)) {
            langArr.push(lang.value);
          }
        });
        setLangs(langArr);
      })
      .catch(error => console.error(error));
  }

  const fetchRegions = () => {
    // Load the region select options
    // 
    const locArr = [];
    fetch(`${apptsUrl}getRegions`)
      .then(response => response.json())
      .then(data2 => {
        data2.forEach((region) => {
          if (region.value && !locArr.includes(region.value)) {
            locArr.push(region.value);
          }
        });
        setLocs(locArr);
      })
      .catch(error => console.error(error));
  }

  // auto-refresh
  const refreshMaster = () => {
    // update time
    try {
      setNow(format(new Date().toLocaleString(), 'eee HH:mm:ss'));
      fetchMetrics();
    } catch (error) {
      console.error(error);
    }
  };

  const fetchMetrics = () => {
    // retrieve and then setData()
    // https://dev.cherry2024.com:2096/getSayers
    // 
    fetch(`${apptsUrl}getSayers`)
      .then(response => response.json())
      .then(data => {
        setMaster(data);
      })
      .catch(error => console.error(error));
  }

  // Exports
  const exportsClose = () => setExportActive(false);
  const exportsShow = () => setExportActive(true);
  function exportCSV(exportType) {
    // This clears the nulls into strings
    const replacer = (key, value) => value ?? '';
    // The column names. This sets the columns for an extract  Object.keys(masterlist[0])
    var headerRow = [];
    var fileName = "newExport";
    switch (exportType) {
      case 'Sayers':
        // The column names
        headerRow = ['sayername', 'sayerphone', 'sayeremail', 'sayerspeaks', 'sayeraddress', 'sayerregion', 'sayerapptcount'];
        fileName = "Cherry2024Interpreters";
        break;
      default:
        break;
    }
    // make the rows
    const rowItems = masterlist
      .filter(sayer => (
        (!exportNoPhone || (exportNoPhone && !sayer.sayerphone)) &&
        (!exportNoAddress || (exportNoAddress && !sayer.sayeraddress))
      ))
      .map((row) =>
        headerRow.map((fieldName) => JSON.stringify(row[fieldName], replacer)).join(',')
      );
    // glue it all together into a link and click on it
    const csv = [headerRow, ...rowItems].join('\r\n');
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.download = fileName + ".csv";
    link.href = url;
    link.click();
  }

  return (
    <div>
      <Offcanvas show={exportActive} onHide={exportsClose} className="mt-2"
        data-bs-theme="dark">
        <Offcanvas.Header className="sidebarright">
          <Offcanvas.Title>Interpreter Export&nbsp;&nbsp;&nbsp;</Offcanvas.Title>
          <button className="btn btn-sm btn-outline-warning" onClick={exportsClose}>Close</button>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Stack className="sidebarright" gap={3}>
            <div className="p-2 roweven row">
              <span >&nbsp;This export contains the following columns:<br></br>
                • Name<br></br>
                • Phone<br></br>
                • Email<br></br>
                • Languages<br></br>
                • Address<br></br>
                • Region<br></br>
                • Count
                <hr></hr>
                Export Interpreters missing a phone number
                <ToggleButton
                  className="mb-2"
                  id="toggle-phone"
                  type="checkbox"
                  variant="outline-primary"
                  checked={exportNoPhone}
                  value="true"
                  onChange={(e) => setExportNoPhone(e.currentTarget.checked)}
                >
                  No Phone
                </ToggleButton>
                <hr></hr>
                Export Interpreters missing an address
                <ToggleButton
                  className="mb-2"
                  id="toggle-address"
                  type="checkbox"
                  variant="outline-primary"
                  checked={exportNoAddress}
                  value="true"
                  onChange={(e) => setExportNoAddress(e.currentTarget.checked)}
                >
                  No Address
                </ToggleButton>
                <hr></hr>

                <button className={btnNormal} title="EXPORT INTERPRETERS" onClick={() => [exportCSV('Sayers')]}>Click Here to Export<br></br>"Interpreters"</button>
                <hr></hr>
              </span>
            </div>
          </Stack>
        </Offcanvas.Body>
      </Offcanvas>
      {masterlist ?
        <div className="roweven topLine1">
          <div>
            {userGrid()}
          </div>
          {langsSelect ?
            <Offcanvas show={langsSelect} className="mt-2 h-auto" data-bs-theme="dark" placement='bottom' scroll='true' backdrop='false'>
              <Offcanvas.Body>
                <Text style={[styles.text]} >
                  <button className="btn btn-sm btn-outline-warning" title="Close SPEAKS" onClick={() => [setLangsSelect(false)]}>Close</button>&nbsp;
                  {langs
                    .map((item, index) => (
                      <button className={Array.from(filterLangs).includes(item) ? btnSelectOn : btnSelect} onClick={() => filterLangs.includes(item) ? setFilterLangs([...filterLangs.filter(lang => item !== lang)]) : setFilterLangs([...filterLangs, item])} key={item.id}>{item}
                      </button>
                    ))
                  }
                  <button className="btn btn-sm btn-outline-warning" title="Close SPEAKS" onClick={() => [setLangsSelect(false)]}>Close</button>&nbsp;
                </Text>
              </Offcanvas.Body>
            </Offcanvas>
            : <span>&nbsp;</span>}
          {locsSelect ?
            <Offcanvas show={locsSelect} className="mt-2 h-auto" data-bs-theme="dark" placement='bottom'>
              <Offcanvas.Body>
                <Text style={[styles.text]}>
                  <button className="btn btn-sm btn-outline-warning" title="Close COVERAGE" onClick={() => [setLocsSelect(false)]}>Close</button>&nbsp;
                  {locs
                    .sort((a, b) =>
                      (a.toLowerCase() > b.toLowerCase()) ? 1 :
                        ((b.toLowerCase() > a.toLowerCase()) ? -1 : 0))
                    .map((item, index) => (
                      <button className={Array.from(filterLocs).includes(item) ? btnActive : btnNormal} onClick={() => filterLocs.includes(item) ? setFilterLocs([...filterLocs.filter(loc => item !== loc)]) : setFilterLocs([...filterLocs, item])} key={item.id}>{item}
                      </button>
                    ))
                  }
                  <button className="btn btn-sm btn-outline-warning" title="Close COVERAGE" onClick={() => [setLocsSelect(false)]}>Close</button>&nbsp;
                </Text>
              </Offcanvas.Body>
            </Offcanvas>
            : <span>&nbsp;</span>}
        </div>
        : <h4>&nbsp;&nbsp;Loading Fresh Master List...</h4>}
    </div>
  );
};

export default SayerPanel;


function createStyles() {
  return StyleSheet.create({
    container: {
      flex: 1,
      flexDirection: 'column',
      backgroundColor: 'black',
      // backgroundColor: theme.background,
    },

    // data grid
    textName: {
      fontSize: '1.3em',
      flex: 3,
    },
    texttall: {
      fontSize: '1.3em',
      marginLeft: '10px',
    },
    colwide: {
      width: '100px',
    },
    colthin: {
      width: '40px',
    },


    text: {
      // color: theme.rowtext,
      color: 'white',
      fontSize: '1.1em',
      textAlign: 'left',
      // backgroundColor: theme.rowbg,
      backgroundColor: 'rgba(10, 134, 134, 0.2)',
      flex: 2,
    },
    textflexbig: {
      // color: theme.rowtext,
      color: 'white',
      fontSize: '1.1em',
      textAlign: 'left',
      // backgroundColor: theme.rowbg,
      backgroundColor: 'rgba(10, 134, 134, 0.2)',
      flex: 4,
    },
    textthin: {
      //      color: theme.rowtext,
      color: 'white',
      fontSize: '1.1em',
      textAlign: 'left',
      // backgroundColor: theme.rowbg,
      backgroundColor: 'rgba(10, 134, 134, 0.2)',
      flex: 1,
    },
    text1: {
      // color: theme.text,
      color: 'white',
      fontSize: '1.2em',
      fontWeight: 'bold',
      textAlign: 'left',
      // backgroundColor: theme.rowbg,
      backgroundColor: 'rgba(10, 134, 134, 0.2)',
      flex: 2,
    },
    text1thin: {
      // color: theme.text,
      color: 'white',
      fontSize: '1.2em',
      fontWeight: 'bold',
      textAlign: 'left',
      // backgroundColor: theme.rowbg,
      backgroundColor: 'rgba(10, 134, 134, 0.2)',
      flex: 1,
    },
    nametext: {
      color: 'gold',
      backgroundColor: 'white',
      fontSize: '1.1em',
      textAlign: 'left',
      // backgroundColor: theme.rowbg,
      backgroundColor: 'rgba(10, 134, 134, 0.2)',
      flex: 4,
    },
    rush: {
      color: 'red',
      fontSize: '1.1em',
      textAlign: 'center',
      // backgroundColor: theme.background,
      backgroundColor: 'white',
    },
    title: {
      // color: theme.header,
      color: 'orange',
      fontSize: '1.5em',
      fontWeight: 'bold',
      textAlign: 'left',
      // backgroundColor: theme.background,
      backgroundColor: 'black',
      width: "90%"
    },
    link: {
      // color: theme.text,
      color: 'white',
      fontSize: 42,
      fontWeight: 'bold',
      textAlign: 'center',
      backgroundColor: 'rgba(16,0,16,0.7)',
      textDecorationLine: 'underline',
    },
    button: {
      height: 40,
      borderRadius: 5,
      padding: 6,
      // backgroundColor: theme.button,
      backgroundColor: 'royalblue',
      justifyContent: 'center',
    },
    butttonText: {
      // color: theme.text,
      color: 'white',
      fontSize: 16,
      fontWeight: 'bold',
      textAlign: 'center',
      verticalAlign: 'middle',
      padding: 4,
    },
    icon: {
      // color: theme.text,
      color: 'white',
      fontSize: 36,
      // backgroundColor: theme.background,
      backgroundColor: 'black',
      textAlign: 'right',
      verticalAlign: 'middle',
      padding: 1,
      width: '10%'
    },
    viewrow: {
      flexDirection: 'row',
      width: '95%',
    },
    row: {
      height: '100',
      width: '95%',
      flexDirection: 'row',
      marginBottom: 2,
      backgroundColor: 'rgba(16,0,16,0.7)',
      // borderColor: 'white',
      // borderWidth: 2,
      // borderStyle: 'solid',
      // borderRadius: 5,
    },
    row2: {
      height: '100',
      width: '100%',
      flexDirection: 'row',
      backgroundColor: 'black',
      marginBottom: 2,
    },
    rowodd: {
      width: '95%',
      backgroundColor: 'black',
      borderBottomStyle: 'solid',
      borderBottomWidth: '2px',
      borderBottomColor: 'rgba(10, 134, 134, 0.4)',
    },
    roweven: {
      width: '95%',
      backgroundColor: 'rgba(32,0,32,0.7)',
      borderBottomStyle: 'solid',
      borderBottomWidth: '2px',
      borderBottomColor: 'rgba(134, 101, 10, 0.4)',
    },
    sep: {
      height: 3,
      backgroundColor: 'gray',
      width: '50%',
      maxWidth: 400,
      marginHorizontal: 'auto',
      marginBottom: 2,
    },
    apptButon: {
      marginLeft: "15px",
      marginRight: "15px",
    },
    apptBase: {
      borderRadius: "5px",
      borderWidth: "1px",
      boxShadow: "none",
      borderStyle: "solid",
      borderColor: "rgb(13, 202, 240)",
      backgroundColor: 'black',
      color: "rgb(13, 202, 240)",
    },
    apptWaiting: {
      borderRadius: "5px",
      boxShadow: "none",
      borderStyle: "solid",
      backgroundColor: 'black',
      borderColor: "gold",
      color: 'gold',
    },
    apptGood: {
      borderRadius: "5px",
      boxShadow: "none",
      borderStyle: "solid",
      backgroundColor: 'black',
      borderColor: "lightgreen",
      color: 'lightgreen',
    },

    selectTop: {
      position: "fixed",
      marginTop: "150px",
      display: "block",
      zIndex: "200",
      backgroundColor: "black",
      borderColor: "cornflowerblue",
      borderWidth: "3px",
      padding: "5px",
    },

    image: {
      height: '100%',
      width: 'auto',
      flex: 1,
      justifyContent: 'center',
    }
  })
}


